import { ProductCategory } from "../types";

const getProductCategory = (
  productCategory?: string
): ProductCategory | undefined => {
  if (!productCategory) {
    return undefined;
  }

  return Object.values(ProductCategory).find(
    (i) => i === productCategory.toLowerCase()
  );
};

export default getProductCategory;
